module.exports = __webpack_public_path__ + "img/completed.0522a44f.png";